<script setup lang="ts">
    import type { FrontendFieldDefinition } from '@hmmh/storyblok-forms/client';
    import type { FormRadioGroupStoryblok } from '~/.storyblok/types/FormRadioGroupStoryblok';
    import FormRadioGroup from '~/storyblok/Form/FormRadioGroup.vue';
    import { isRequiredField, useFormFieldId } from './form-field-utils';

    const props = defineProps<{ field: FrontendFieldDefinition }>();
    const inputId = useFormFieldId();

    const blok = computed<FormRadioGroupStoryblok>(() => ({
        _uid: inputId,
        component: 'FormRadioGroup',
        inputKey: props.field.name,
        title: `${props.field.label}${isRequiredField(props.field) ? ' *' : ''}`,
        options: (props.field.options ?? []).map((option, index) => ({
            _uid: `${inputId}-${index}`,
            component: 'FormRadioInput',
            label: option.value,
            value: option.key
        }))
    }));
</script>

<template>
    <FormRadioGroup
        :blok="blok"
        val=""
    />
</template>
